// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"bT-z","inlineTitle":"cT-z","sponsoredAdsWrapper":"dT-z","marketplaceRecosWrapper":"eT-z"};